module.exports = __webpack_public_path__ + "static/media/driver.daf6c819.png";